import { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { HomePanel } from './router-panels'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { StaticPanelWappId } from '$logic/wapp-panels'

const Container = styled('div')`
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateZ(0) translateY(70%) scale(0.2);
  transition: transform, opacity, border-radius;
  transition-duration: 200ms;
  transition-timing-function: ease-out;
  border-radius: 200px;
  overflow: hidden;
`

export function Rahkar() {
  const navigate = useNavigate()
  const containerRef = useRef<HTMLDivElement>(null)

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'rahkar'
  const [delayedIsTop, setDelayedIsTop] = useState(isTop)

  useEffect(() => {
    if (isTop) {
      setDelayedIsTop(true)
      return
    }

    // TODO[router]: Refactor
    const timeout = setTimeout(() => setDelayedIsTop(false), 250)
    return () => clearTimeout(timeout)
  }, [isTop])

  // TODO[router]: Implement <ToggleTransition /> in router and use that!
  useEffect(() => {
    setTimeout(() => {
      if (!containerRef.current) return

      containerRef.current.style.opacity = isTop ? '1' : '0'
      containerRef.current.style.borderRadius = isTop ? '0' : '200px'
      containerRef.current.style.transform = `translateZ(0) translateY(${
        isTop ? '0' : '70%'
      }) scale(${isTop ? 1 : 0.2})`
    }, 50)
  }, [isTop])

  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('rahkar')
      if (panelHistory.length > 1) navigate(-1)
      else HomePanel.navigate(-1)
    },
    [],
    isTop,
  )

  return (
    <VisibilityHandler
      zIndex={2}
      freezeChildren={!delayedIsTop}
      considerIOSNotch
      style={{ position: 'fixed' }}
    >
      <Container ref={containerRef}>
        <StaticWappPanel
          panelName="rahkar"
          wappId={StaticPanelWappId.RAHKAR}
          input={{ mode: 'REELS' }}
        />
      </Container>
    </VisibilityHandler>
  )
}
